"use strict";

ONIBUS.pageScript = ONIBUS.pageScript || {
  init: {}
};

ONIBUS.pageScript = function () {
  // コンストラクタ  =================================================================
  function init() {}

  return {
    init: init
  };
}();
ONIBUS.common.init(ONIBUS.pageScript.init);